import { createEntityAdapter } from '@reduxjs/toolkit';

import { ITopic } from 'api/topics/types';
import { IRootState } from '../types';

export const topicsAdapter = createEntityAdapter<ITopic>({
  selectId: (topic) => topic.id as string,
  sortComparer: (a, b) => {
    if (a.count > b.count) {
      return -1;
    }

    if (a.count < b.count) {
      return 1;
    }

    return 0;
  },
});

export const selectors = topicsAdapter.getSelectors<IRootState>(
  (state) => state.topics,
);
